class Tile {
  constructor(name, desc, blocking, opaque, ocean) {
    this.name = name;
    this.description = desc;
    this.blocking = blocking;
    this.opaque = opaque;
    this.ocean = ocean;
    this.isOpenable = false;
  }
}

class TeleporterTile extends Tile {
  constructor(name, desc, tx, ty) {
    super(name, desc, false, false, false);
    this.isTeleporter = true;
    this.teleportX = tx;
    this.teleportY = ty;
  }
}

class PortalTile extends Tile {
  constructor(name, desc, level, target=false) {
    // console.log(`new PortalTile`);
    // console.log(`---tile: ${name}`);
    // console.log(`---level: ${level}`);
    // console.log(`---target: ${target.x},${target.y}`);
    super(name, desc, false, false, false);
    this.level = level;
    this.target = target;
  }
}

class ClosedDoorTile extends Tile {
  constructor(name, desc, openTile) {
    super(name, desc, true, true, false);
    this.openTile = openTile;
    this.isOpenable = true;
  }
}

class OpenDoorTile extends Tile {
  constructor(name, desc, closedTile) {
    super(name, desc, false, false, false);
    this.closedTile = closedTile;
  }
}

Tile.ocean = (type, desc) => new Tile(type, desc, false, false, true);
Tile.land = (type, desc) => new Tile(type, desc, false, false, false);
Tile.terrain = (type, desc) => new Tile(type, desc, true, true, false);
Tile.scenery = (type, desc) => new Tile(type, desc, true, false, false);
Tile.teleporter = (type, desc, tx, ty) => new TeleporterTile(type, desc, tx, ty);
Tile.doorClosed = (type, desc, switchTo) => new ClosedDoorTile(type, desc, switchTo);
Tile.doorOpen = (type, desc, switchTo) => new OpenDoorTile(type, desc, switchTo);
Tile.portal = (type, desc, level, target=false) => new PortalTile(type, desc, level, target);
Tile.emptyPortal = (type, desc) => new PortalTile(type, desc, false, false);

export default Tile;
